import {useEffect, useRef} from 'react';
import {isLocal} from '@Libraries/environment-library';

/**
 * Attaches a stats.js panel (FPS / ms / MB) to the poster editor in local dev.
 * Click the panel to cycle between views.
 * The panel is only loaded and shown when running locally.
 */
export function usePerformanceStats(): void {
  const statsRef = useRef<{dom: HTMLElement; begin: () => void; end: () => void} | null>(null);

  useEffect(() => {
    if (!isLocal()) {
      return;
    }

    let rafId: number;
    let mounted = true;

    void import('stats.js').then((module) => {
      if (!mounted) {
        return;
      }

      const StatsConstructor = module.default;
      const stats = new StatsConstructor();
      stats.dom.style.cssText = 'position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:100000';
      document.body.appendChild(stats.dom);
      statsRef.current = stats;

      const animate = (): void => {
        stats.update();
        rafId = requestAnimationFrame(animate);
      };
      rafId = requestAnimationFrame(animate);
    });

    return (): void => {
      mounted = false;
      if (statsRef.current) {
        cancelAnimationFrame(rafId);
        statsRef.current.dom.remove();
        statsRef.current = null;
      }
    };
  }, []);
}
